import { useMemo } from 'react'
import { OrderState } from '../state/orderState'

const useActiveItem = ({ items, activeItemId }: OrderState) => {
  const active = useMemo(
    () => items.find((item) => item.id === activeItemId),
    [items, activeItemId]
  )

  return active
}

export default useActiveItem
